import React, { useState, useEffect } from 'react'
import {
  Form,
  Button,
  Modal,
  Container,
  Row,
  Col,
  Card,
  Dropdown} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import {
  BsFunnelFill,
  BsSearch,
  BsArrowClockwise,
  BsThreeDotsVertical,
  BsPencilFill,
  BsBookFill,
  BsCashStack} from 'react-icons/bs'
import {
  LuGraduationCap} from 'react-icons/lu'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import toast from 'react-hot-toast'
import EditCourseModal from './EditCourseModal'
import Cookies from 'js-cookie'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import TablePagination from './commonComponents/TablePagination'
import { useInstitute } from './commonComponents/InstituteContext'
import { useNavigate } from 'react-router-dom'

const DataTable = () => {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo, name, id } = useInstitute();
  const [showFilterCard, setShowFilterCard] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  const initialData = []

  const [data, setData] = useState(initialData)
  const [search, setSearch] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [showModal, setShowModal] = useState(false)
  const [showEditModal, setShowEditModal] = useState(false)
  const [selectedCourse, setSelectedCourse] = useState(null)
  const [user, setUser] = useState(null)
  const [userRole, setUserRole] = useState([])
  const [allCourses, setAllCourses] = useState([])
  const [loading, setLoading] = useState(false)
  const [isAcknowledged, setIsAcknowledged] = useState(false)

  useEffect(() => {
    const instituteId = Cookies.get('institute_id')
    if (!instituteId) {
      setData([])
      setAllCourses([])
      console.error('No Institute ID found. Cannot fetch courses.')
      return
    }

    ApiEndpoints.getAllCourses()
      .then((response) => {
        const allCourses = response.data.data || []
        setData(allCourses)
        setAllCourses(allCourses)
      })
      .catch((error) => {
        toast.error('Failed to access data.')
      })
  }, [loading])

  useEffect(() => {
    const userLogged = Cookies.get('user')
    console.log('userLogged', userLogged)
    if (userLogged) {
      try {
        setUser(JSON.parse(userLogged))
         setUserRole(JSON.parse(userLogged))
        console.log('User:', JSON.parse(userLogged))
      } catch (error) {
        console.error('Error parsing user data:', error)
        Cookies.remove('user')
      }
    }
  }, [])

  const [newCourse, setNewCourse] = useState({
    course_name: '',
    duration: '',
    fee: '',
    description: ''})

  const [selectedData, setSelectedData] = useState({})

  const fetchFilteredData = (selectedValues) => {
    const { course } = selectedValues
    let updatedData = allCourses
    console.log('updatedData', updatedData)
    if (course) {
      updatedData = updatedData.filter(
        (item) => item.id?.toString() === course.toString(),
      )
    }

    setData(updatedData)
  }

  useEffect(() => {
    fetchFilteredData(selectedData)
  }, [])
  // Filter Data Based on Search
  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      value !== null && value !== undefined
        ? value.toString().toLowerCase().includes(search.trim().toLowerCase())
        : false,
    ),
  )

  // Pagination Logic
  const totalPages = Math.ceil(filteredData.length / itemsPerPage)
  useEffect(() => {
    if (currentPage > totalPages && totalPages !== 0) {
      setCurrentPage(1)
    }
  }, [filteredData, totalPages])

  const indexOfLastItem = currentPage * itemsPerPage
  const indexOfFirstItem = indexOfLastItem - itemsPerPage
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem)

  // Handle Form Input
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewCourse((prev) => ({ ...prev, [name]: value }))
  }

  const handleSave = async (e) => {
    e.preventDefault()
    if (!id) {
      toast.error('No institute selected. Please switch institute from the header first.')
      return
    }
    try {
      setLoading(true)
      const response = await ApiEndpoints.addCourse(newCourse, id)
      console.log('Sending Response: ', response)

      setNewCourse(response)
      setNewCourse({ course_name: '', duration: '', fee: '', description: '' })

      toast.success(response.data.result)
      setShowModal(false)
    } catch (error) {
      toast.error(error.response?.data?.result || 'Something went wrong.')
      setShowModal(false)
    } finally {
      setLoading(false)
    }
  }

  const handleRefresh = async () => {
    setSelectedData({})
    setData(allCourses)
    setSearch('')
    setCurrentPage(1)
  }

  return (
    <>
      <style>
        {`
          .dropdown-toggle-no-caret::after {
            display: none !important;
          }
        `}
      </style>
      <div 
        style={{ 
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          marginRight: '0px',
          marginBottom: '0px',
          paddingLeft: isCollapsed ? '12px' : '12px',
          paddingRight: isCollapsed ? '12px' : '12px'}}
      >
        {/* Header */}
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px'}}
        >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div 
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%'}}
          >
            {/* Left: Title and Add Course Button */}
            <div className="d-flex align-items-center gap-3">
              {/* School Logo */}
              <div style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                overflow: 'hidden', 
                background: '#223843',
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0}}>
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="School Logo" 
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>
              
              <h3 
                className="m-0 fw-bold" 
                style={{ 
                  letterSpacing: '-0.02em',
                  overflow: 'visible',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: 'clamp(18px, 2.5vw, 22px)',
                  color: '#223843',
                  lineHeight: '1.2',
                  fontFamily: 'Inter, system-ui, sans-serif'}}
              >
                Manage Courses
              </h3>
              {/* {(user?.user_type === 'admin' || userRole?.roles?.includes("admin")) && (
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#223843',
                    border: 'none',
                    color: '#ffffff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease',
                    flexShrink: 0}}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1.05)'
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#223843'
                    e.currentTarget.style.transform = 'scale(1)'
                  }}
                  title="Add New Course"
                >
                  <BsBookFill size={20} />
                </button>
              )} */}
            </div>
            
            {/* Right: Profile Icon with Dropdown */}
            {!isMobile && (
              <ProfileDropdown logout={logout} />
            )}
          </div>
        </div>
        </div>
        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '32px',
            paddingBottom: '32px'}}
        >
          {/* Filter Toggle Button and Items Per Page */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div className="d-flex align-items-center gap-3">
              {/* Items Per Page Selector */}
              <div 
                className="d-flex align-items-center"
                style={{
                  backgroundColor: '#ffffff',
                  padding: '8px 16px',
                  borderRadius: '8px',
                  gap: '8px',
                  border: '1px solid #D1D3D4'}}
              >
                <span style={{ color: '#6b7280', fontSize: '13px', whiteSpace: 'nowrap', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Show:
                </span>
                <Form.Select
                  className="w-auto"
                  value={itemsPerPage}
                  onChange={(e) => {
                    setItemsPerPage(parseInt(e.target.value))
                    setCurrentPage(1)
                  }}
                  style={{
                    borderRadius: '6px',
                    border: '1px solid #D1D3D4',
                    backgroundColor: '#ffffff',
                    color: '#111827',
                    fontSize: '13px',
                    fontWeight: '500',
                    padding: '4px 32px 4px 12px',
                    minWidth: '140px',
                    transition: 'all 0.2s ease',
                    cursor: 'pointer',
                    height: '36px',
                    fontFamily: 'Inter, system-ui, sans-serif'}}
                  onFocus={(e) => {
                    e.target.style.borderColor = '#223843'
                  }}
                  onBlur={(e) => {
                    e.target.style.borderColor = '#D1D3D4'
                  }}
                >
                  <option value="10">10 per page</option>
                  <option value="20">20 per page</option>
                  <option value="30">30 per page</option>
                </Form.Select>
              </div>
              <button
                onClick={() => setShowFilterCard(!showFilterCard)}
                style={{
                  width: '48px',
                  height: '48px',
                  borderRadius: '50%',
                  backgroundColor: showFilterCard ? '#223843' : '#ffffff',
                  border: '1px solid #D1D3D4',
                  color: showFilterCard ? '#ffffff' : '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.color = '#ffffff'
                  e.currentTarget.style.borderColor = showFilterCard ? '#223843' : '#223843'
                  e.currentTarget.style.transform = 'scale(1.05)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = showFilterCard ? '#223843' : '#ffffff'
                  e.currentTarget.style.color = showFilterCard ? '#ffffff' : '#223843'
                  e.currentTarget.style.borderColor = '#D1D3D4'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title={showFilterCard ? 'Hide Filters' : 'Show Filters'}
              >
                <BsFunnelFill size={20} />
              </button>
            </div>

            {/* Add New — desktop toolbar (mobile copy below, match CreateAnnouncement.js) */}
            
            {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff") || userRole?.roles?.includes("teacher")) && (
              <button
                type="button"
                className="d-none d-md-flex align-items-center justify-content-center"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Course"
              >
                <BsBookFill size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Course
                </span>
              </button>
            )}
          </div>

          {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff")) && (
            <div className="d-md-none d-flex justify-content-end mb-4">
              <button
                type="button"
                onClick={() => setShowModal(true)}
                style={{
                  borderRadius: '10px',
                  padding: '6px 10px',
                  height: '44px',
                  border: 'none',
                  backgroundColor: '#223843',
                  color: '#ffffff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '6px',
                  cursor: 'pointer',
                  transition: 'all 0.2s ease',
                  whiteSpace: 'nowrap'}}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#1f323a'
                  e.currentTarget.style.transform = 'scale(1.03)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#223843'
                  e.currentTarget.style.transform = 'scale(1)'
                }}
                title="Add New Course"
              >
                <BsBookFill size={18} />
                <span style={{ fontSize: '12px', fontWeight: '650', fontFamily: 'Inter, system-ui, sans-serif' }}>
                  Add New Course
                </span>
              </button>
            </div>
          )}

          {/* Modern Filter Section */}
          <div 
            style={{
              maxHeight: showFilterCard ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              marginBottom: showFilterCard ? '24px' : '0'}}
          >
            {showFilterCard && (
              <Card 
                style={{
                  border: '1px solid #D1D3D4',
                  borderRadius: '12px',
                  backgroundColor: '#ffffff',
                  overflow: 'hidden'}}
              >
                {/* Header */}
                <div 
                  style={{
                    background: '#ffffff',
                    padding: '20px',
                    borderBottom: '1px solid #F3F4F6'}}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                      <div 
                        style={{
                          width: '40px',
                          height: '40px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'}}
                      >
                        <BsSearch style={{ color: '#ffffff', fontSize: '18px' }} />
                      </div>
                      <div>
                        <h5 className="m-0 fw-semibold text-start" style={{ color: '#111827', fontSize: '16px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                          Search & Filter Courses
                        </h5>
                        <p className="m-0 mt-1" style={{fontSize: '13px', color: '#6b7280' }}>
                          Find courses quickly with advanced filters
                        </p>
                      </div>
                    </div>
                    <div className="d-flex gap-2">
                      <button
                        onClick={handleRefresh}
                        style={{
                          width: '48px',
                          height: '48px',
                          borderRadius: '50%',
                          backgroundColor: '#223843',
                          border: 'none',
                          color: '#ffffff',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          cursor: 'pointer',
                          transition: 'all 0.2s ease'}}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1.05)'
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = '#223843'
                          e.currentTarget.style.transform = 'scale(1)'
                        }}
                        title="Refresh"
                      >
                        <BsArrowClockwise size={20} />
                      </button>
                    </div>
                  </div>
                </div>

                <Card.Body className="p-4" style={{ backgroundColor: '#ffffff' }}>
                  <Row className="g-4 text-start">
                    {/* Filter by Course Name */}
                    <Col xs={12}>
                      <div style={{ 
                        padding: '20px', 
                        backgroundColor: '#F3F4F6', 
                        borderRadius: '8px',
                        border: '1px solid #D1D3D4'}}>
                        <div className="d-flex align-items-center gap-2 mb-3">
                          <div 
                            style={{
                              width: '32px',
                              height: '32px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'}}
                          >
                            <BsSearch style={{ color: '#ffffff', fontSize: '16px' }} />
                          </div>
                          <label className="fw-semibold mb-0" style={{ color: '#111827', fontSize: '14px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                            Filter by Course Name
                          </label>
                        </div>
                        <Row className="g-3">
                          {/* Search Course Name */}
                          <Col xs={12}>
                            <div style={{ position: 'relative' }}>
                              <label className="fw-semibold mb-2 d-block" style={{ color: '#6b7280', fontSize: '13px', fontFamily: 'Inter, system-ui, sans-serif' }}>
                                Search Course Name
                              </label>
                              <div style={{ position: 'relative' }}>
                                <BsSearch 
                                  style={{ 
                                    position: 'absolute', 
                                    left: '12px', 
                                    top: '50%', 
                                    transform: 'translateY(-50%)',
                                    color: '#6b7280',
                                    fontSize: '16px',
                                    zIndex: 1}} 
                                />
                                <Form.Control
                                  type="text"
                                  value={search}
                                  onChange={(e) => setSearch(e.target.value)}
                                  placeholder="Enter course name..."
                                  style={{
                                    paddingLeft: '40px',
                                    borderRadius: '8px',
                                    border: '1px solid #D1D3D4',
                                    fontSize: '14px',
                                    height: '40px',
                                    transition: 'all 0.2s ease',
                                    backgroundColor: '#ffffff',
                                    fontFamily: 'Inter, system-ui, sans-serif'}}
                                  onFocus={(e) => {
                                    e.target.style.borderColor = '#223843'
                                  }}
                                  onBlur={(e) => {
                                    e.target.style.borderColor = '#D1D3D4'
                                  }}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            )}
          </div>

        {/* Table */}
        <Card style={{ border: '1px solid #D1D3D4', borderRadius: '12px', overflow: 'hidden', backgroundColor: '#ffffff' }}>
          <Table className="table mb-0" style={{ borderRadius: '12px', overflow: 'hidden' }}>
            <Thead>
              <Tr style={{ backgroundColor: '#F3F4F6' }}>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Course Name</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Duration</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Fee</Th>
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Description</Th>
                {/* {user?.user_type !== 'teacher' && (
                  <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>
                )} */}
                <Th style={{ fontSize: '13px', fontWeight: '600', padding: '16px', border: 'none', borderBottom: '1px solid #D1D3D4', textAlign: 'left', color: '#111827', fontFamily: 'Inter, system-ui, sans-serif' }}>Action</Th>

              </Tr>
            </Thead>
            <Tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <Tr 
                    key={index}
                    style={{ 
                      backgroundColor: index % 2 === 0 ? '#ffffff' : '#F3F4F6',
                      transition: 'background-color 0.2s ease',
                      borderBottom: '1px solid #D1D3D4'}}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor = '#F3F4F6'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#F3F4F6'
                    }}
                  >
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.name}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.duration}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>₹ {item.fee}</Td>
                    <Td style={{ fontSize: '14px', padding: '16px', border: 'none', color: '#111827', textAlign:"left", fontFamily: 'Inter, system-ui, sans-serif' }}>{item.description}</Td>
                    {(user?.user_type === 'admin' || user?.user_type === 'staff' || userRole?.roles?.includes("admin") || userRole?.roles?.includes("staff") || userRole?.roles?.includes("teacher")) && (
                      <Td className="text-center" style={{ padding: '16px', border: 'none' }}>
                        {/* Desktop View - Dropdown */}
                        <div className="d-none d-md-block">
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="light"
                              id={`dropdown-${item.id}`}
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: 'transparent',
                                border: '1px solid #D1D3D4',
                                padding: '0',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'all 0.2s ease'}}
                              className="dropdown-toggle-no-caret"
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#223843'
                                e.currentTarget.style.borderColor = '#223843'
                                e.currentTarget.style.color = '#ffffff'
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent'
                                e.currentTarget.style.borderColor = '#D1D3D4'
                                e.currentTarget.style.color = '#111827'
                              }}
                            >
                              <BsThreeDotsVertical style={{ color: 'inherit' }} />
                            </Dropdown.Toggle>

                            <Dropdown.Menu
                              style={{
                                borderRadius: '8px',
                                border: '1px solid #D1D3D4',
                                padding: '8px',
                                minWidth: '180px'}}
                            >
                              <Dropdown.Item
                                onClick={() => {
                                  setSelectedCourse(item)
                                  setShowEditModal(true)
                                }}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsPencilFill size={18} /> Edit Course
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => navigate('/FeeStructure')}
                                style={{
                                  fontSize: '13px',
                                  padding: '10px 12px',
                                  color: '#111827',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '10px',
                                  transition: 'all 0.2s ease',
                                  borderRadius: '6px',
                                  fontFamily: 'Inter, system-ui, sans-serif'}}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = '#10B981'
                                  e.currentTarget.style.color = '#ffffff'
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent'
                                  e.currentTarget.style.color = '#111827'
                                }}
                              >
                                <BsCashStack size={18} /> Add Fee
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>

                        {/* Mobile View - Circular Buttons in Single Line */}
                        <div className="d-md-none d-flex justify-content-start align-items-center gap-2">
                          <button
                            onClick={() => {
                              setSelectedCourse(item)
                              setShowEditModal(true)
                            }}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#10B981',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#059669'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#10B981'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Edit Course"
                          >
                            <BsPencilFill size={16} />
                          </button>
                          <button
                            type="button"
                            onClick={() => navigate('/FeeStructure')}
                            style={{
                              width: '36px',
                              height: '36px',
                              borderRadius: '50%',
                              backgroundColor: '#223843',
                              border: 'none',
                              color: '#ffffff',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer'}}
                            onMouseEnter={(e) => {
                              e.currentTarget.style.backgroundColor = '#1a2d35'
                              e.currentTarget.style.transform = 'scale(1.1)'
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor = '#223843'
                              e.currentTarget.style.transform = 'scale(1)'
                            }}
                            title="Add Fee"
                          >
                            <BsCashStack size={16} />
                          </button>
                        </div>
                      </Td>
                    )}
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={user?.user_type !== 'teacher' ? "5" : "4"} className="text-center" style={{ padding: '40px', fontSize: '14px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif' }}>
                    No records found
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </Card>


        {/* Pagination & Total Records */}


                <TablePagination
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalPages={totalPages}
          indexOfFirstItem={indexOfFirstItem}
          indexOfLastItem={indexOfLastItem}
          totalItems={filteredData.length}
          itemLabel="courses"
        />
        </div>
      </div>



      {/* Add Course Modal */}
      <Modal
        size="lg"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <Modal.Header closeButton 
        closeVariant="white"
        className="text-white" style={{backgroundColor: '#223843'}}>
          <Modal.Title>Add New Course</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSave}>
            {/* Course Name */}
            <Form.Group className="mb-3">
              <Form.Label>Course Name *</Form.Label>
              <Form.Control
                type="text"
                name="course_name"
                value={newCourse.course_name}
                onChange={handleInputChange}
                placeholder="Enter Course Name"
                required
              />
            </Form.Group>
            {/* Duration */}
            <Form.Group className="mb-3">
              <Form.Label>Duration *</Form.Label>
              <Form.Control
                type="number"
                name="duration"
                value={newCourse.duration}
                onChange={handleInputChange}
                placeholder="Eg. 6"
                required
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Total Tuition Fee *</Form.Label>
              <Form.Control
                type="text"
                name="fee"
                value={newCourse.fee}
                onChange={handleInputChange}
                placeholder="Enter Tuition Fee"
                required
              />
            </Form.Group>
            <p style={{ fontSize: '12px', color: '#6b7280', fontFamily: 'Inter, system-ui, sans-serif', marginTop:"-10px"}}>Note: This value would be used while creating course fee structure.</p>
            <Form.Group className="mb-3">
              <Form.Label>Description *</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="description"
                value={newCourse.description}
                onChange={handleInputChange}
                placeholder="Enter Course Description"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Check
                className="text-danger"
                type="checkbox"
                id="acknowledgeCheckbox"
                label="I acknowledge and agree that this process is irreversible and cannot be undone."
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
              />
            </Form.Group>

            <Modal.Footer>
              <Button variant="danger" onClick={() => setShowModal(false)}>
                Cancel
              </Button>
              <Button
                variant="success"
                type="submit"
                disabled={!isAcknowledged}
              >
                Save Course
              </Button>
            </Modal.Footer>
          </Form>
        </Modal.Body>
      </Modal>
      
      <EditCourseModal
        show={showEditModal}
        handleClose={() => setShowEditModal(false)}
        course={selectedCourse}
      />
    </>
  )
}

export default DataTable
